<h2 mat-dialog-title>Universal code</h2>
<div mat-dialog-content>
  <p class="code">{{ safeBoxUrl }}</p>
</div>
<div mat-dialog-actions>
  <lib-button variant="stroked" color="primary" (buttonClick)="onCopySafeBoxUrl()">{{ isCopied ? 'Copied!' : 'Copy link' }}</lib-button>
</div>